<template>
    <v-dialog
      :value="dialogService"
      overlay-color="white"
      overlay-opacity="1"
      scrollable
      persistent
      max-width="80vw"
    >
      <v-form
        ref="editorForm"
        class="service d-flex flex-column pa-8"
      >

        <ServiceGeneral
          :service="service"
          :services="services"
          :typeSelect="typeSelect"
          @change-agency="$emit('change-agency', $event)"
          @change-type-icon="$emit('change-type-icon', $event)"
        />
    
        <ServiceImage
          :service="service"
          :selectImageDialog="selectImageDialog"
          :images="$store.state.available_images"
          :getImage="getImage"
          @update-select-image-dialog="$emit('update-select-image-dialog', $event)"
          @select-image="$emit('select-image', $event)"
          @remove-image="$emit('remove-image')"
        />

        <ServiceAllowedDays
          :week="week"
          :getStartDay="getStartDay"
          :getEndDay="getEndDay"
          @change-start-days="changeStartDays"
          @change-end-days="changeEndDays"
        />

        <div class="d-flex flex-row flex-wrap">

          <ServiceConfiguration
            :service="service"
            :durationSelect="durationSelect"
            :unitDurationSelect="unitDurationSelect"
            :priceTable="priceTable"
            :priceTypeSelect="priceTypeSelect"
            :priceDescSelect="priceDescSelect"
            :headersPriceTable="headersPriceTable"
            @save-price-table="$emit('save-price-table', $event)"
            @cancel-price-table="$emit('cancel-price-table', $event)"
            @open-price-table="$emit('open-price-table', $event)"
            @remove-last-week="$emit('remove-last-week')"
            @reset-price-table="$emit('reset-price-table')"
          />

          <ServiceDeposit
            :service="service"
          />

          <ServiceOptions
            :headersAvailableOptions="headersAvailableOptions"
            :updatedAvailableOptions="updatedAvailableOptions"
            :dialogOption="dialogOption"
            :dialogDeleteOption="dialogDeleteOption"
            :editedItemOption="editedItemOption"
            :formTitleOptions="formTitleOptions"
            @add-option="$emit('add-option')"
            @close-option="$emit('close-option')"
            @save-option="$emit('save-option')"
            @update-dialog-delete="$emit('update-dialog-delete', $event)"
            @close-delete-option="$emit('close-delete-option')"
            @delete-option-confirm="$emit('delete-option-confirm')"
            @edit-option="$emit('edit-option', $event)"
            @delete-option="$emit('delete-option', $event)"
          />

          <ServiceRadioGroups
            :headersRadioGroups="headersRadioGroups"
            :updatedAvailableRadioGroups="updatedAvailableRadioGroups"
            :dialogRadioGroup="dialogRadioGroup"
            :dialogDeleteRadioGroup="dialogDeleteRadioGroup"
            :editedRadioGroup="editedRadioGroup"
            :formTitleRadioGroups="formTitleRadioGroups"
            
            :headersRadioOptions="headersRadioOptions"
            :dialogRadioOption="dialogRadioOption"
            :editedRadioOptionItem="editedRadioOptionItem"
            :formTitleRadioOptions="formTitleRadioOptions"

            @close-radio-option="$emit('close-radio-option')"

            @update-dialog-radio-group="$emit('update-dialog-radio-group', $event)"
            @close-radio-group="$emit('close-radio-group')"
            @save-radio-group="$emit('save-radio-group')"

            @add-edit-radio-option="$emit('add-edit-radio-option')"
            @open-radio-option="$emit('open-radio-option', $event)"
            @update-dialog-radio-option="$emit('update-dialog-radio-option', $event)"
            @delete-radio-option="$emit('delete-radio-option', $event)"

            @update-dialog-delete-radio-group="$emit('update-dialog-delete-radio-group', $event)"
            @close-delete-radio-group="$emit('close-delete-radio-group')"
            @delete-radio-group-confirm="$emit('delete-radio-group-confirm')"

            @open-radio-group="$emit('open-radio-group', $event)"
            @delete-radio-group="$emit('delete-radio-group', $event)"
          />
        
          <ServiceRequirements
            :service="service"
            :requirements="requirements"
            :invoiceModes="invoiceModes"
            :spanishLevelSelect="spanishLevelSelect"
          />
          
          <ServiceDescriptions
            :service="service"
            :descriptions="descriptions"
          />

          <ServiceHandbook
            :service="service"
          />

          <ServiceResourcePresets
            :resourcesPresets="resourcesPresets"
            :updatedResourcePreset="updatedResourcePreset"
            :getProjectCategory="getProjectCategory"
            :getProjectName="getProjectName"
            :getTour="getTour"
            :dialogAddResource="dialogAddResource"
            :dialogResource="dialogResource"
            :resourceTypes="resourceTypes"
            :categoriesProjects="categoriesProjects"
            :filterProjects="filterProjects"
            :tourSelect="tourSelect"

            @open-add-resource="$emit('update-dialog-add-resource', true)"
            @update-dialog-add-resource="$emit('update-dialog-add-resource', $event)"
            @add-resource="$emit('add-resource', $event)"
            @edit-resource="$emit('edit-resource', $event)"
            @delete-resource="$emit('delete-resource', $event)"
            @save-resource="$emit('save-resource')"
            @cancel-resource="$emit('cancel-resource', $event)"
          />

        </div>

        <div class="d-flex flex-row pb-8">
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="$emit('close-service-dialog')"
          >
            Cancel
          </v-btn>

          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="saveSevice()"
            :disabled="!hasChanges"
          >
            Save
          </v-btn>
        </div>
      </v-form>
    </v-dialog>
</template>

<script>
  import ServiceAllowedDays from './ServiceAllowedDays.vue'
  import ServiceConfiguration from './ServiceConfiguration.vue'
  import ServiceDeposit from './ServiceDeposit.vue'
  import ServiceOptions from './ServiceOptions.vue'
  import ServiceRadioGroups from './ServiceRadioGroups.vue'
  import ServiceRequirements from './ServiceRequirements.vue'
  import ServiceDescriptions from './ServiceDescriptions.vue'
  import ServiceHandbook from './ServiceHandbook.vue'
  import ServiceResourcePresets from './ServiceResourcePresets.vue'
  import ServiceImage from './ServiceImage.vue'
  import ServiceGeneral from './ServiceGeneral.vue'

  export default {
    name: 'ServiceEditor',

    watch: {
      dialogService(value) {
        if (value) {
          this.$nextTick(() => {
            this.$refs.editorForm?.resetValidation()
          })
        }
      }
    },

    components: {
      ServiceGeneral,
      ServiceImage,
      ServiceAllowedDays,
      ServiceConfiguration,
      ServiceDeposit,
      ServiceOptions,
      ServiceRadioGroups,
      ServiceRequirements,
      ServiceDescriptions,
      ServiceHandbook,
      ServiceResourcePresets,
      
    },

    props: {
      service: {
        type: Object,
        default: () => ({}),
      },

      services: {
        type: Array,
        default: () => [],
      },

      getImage: {
        type: Function,
        required: true,
      },

      typeSelect: {
        type: Array,
        default: () => [],
      },

      week: {
        type: Array,
        default: () => [],
      },

      durationSelect: {
        type: Array,
        default: () => [],
      },

      priceTable: {
        type: Array,
        default: () => [],
      },

      unitDurationSelect: {
        type: Array,
        default: () => [],
      },

      priceTypeSelect: {
        type: Array,
        default: () => [],
      },

      priceDescSelect: {
        type: Array,
        default: () => [],
      },

      headersPriceTable: {
        type: Array,
        default: () => [],
      },

      headersAvailableOptions: {
        type: Array,
        default: () => [],
      },

      updatedAvailableOptions: {
        type: Array,
        default: () => [],
      },

      headersRadioGroups: {
        type: Array,
        default: () => [],
      },

      headersRadioOptions: {
        type: Array,
        default: () => [],
      },

      updatedAvailableRadioGroups: {
        type: Array,
        default: () => [],
      },

      requirements: {
        type: Array,
        default: () => [],
      },

      invoiceModes: {
        type: Array,
        default: () => [],
      },

      spanishLevelSelect: {
        type: Array,
        default: () => [],
      },

      descriptions: {
        type: Array,
        default: () => [],
      },

      resourcesPresets: {
        type: Array,
        default: () => [],
      },

      updatedResourcePreset: {
        type: Object,
        default: () => ({}),
      },

      getStartDay: {
        type: Function,
        required: true,
      },

      getEndDay: {
        type: Function,
        required: true,
      },

      dialogOption: {
        type: Boolean,
        default: false,
      },

      dialogService: {
        type: Boolean,
        default: false,
      },

      dialogDeleteOption: {
        type: Boolean,
        default: false,
      },

      editedItemOption: {
        type: Object,
        default: () => ({}),
      },

      formTitleOptions: {
        type: String,
        default: '',
      },

      dialogRadioGroup: {
        type: Boolean,
        default: false,
      },

      dialogDeleteRadioGroup: {
        type: Boolean,
        default: false,
      },

      formTitleRadioGroups: {
        type: String,
        default: '',
      },

      editedRadioGroup: {
        type: Object,
        required: true
      },

      dialogRadioOption: {
        type: Boolean,
        default: false,
      },

      editedRadioOptionItem: {
        type: Object,
        default: () => ({}),
      },

      formTitleRadioOptions: {
        type: String,
        default: '',
      },

      selectImageDialog: {
        type: Boolean,
        required: true
      },

      getProjectCategory: {
        type: Function,
        required: true
      },

      getProjectName: {
        type: Function,
        required: true
      },

      getTour: {
        type: Function,
        required: true
      },

      dialogAddResource: {
        type: Boolean,
        required: true
      },

      dialogResource: {
        type: Boolean,
        required: true
      },

      resourceTypes: {
        type: Array,
        default: () => [],
      },

      categoriesProjects: {
        type: Function,
        required: true
      },

      filterProjects: {
        type: Function,
        required: true
      },

      tourSelect: {
        type: Array,
        default: () => [],
      },

      hasChanges: {
        type: Boolean,
        required: true
      },

    },

    methods: {

      saveSevice() {
        if (this.$refs.editorForm.validate()) {
          this.$emit('save-service')
        }
      },

      changeStartDays(value, day) {
        this.$emit('change-start-days', value, day)
      },

      changeEndDays(value, day) {
        this.$emit('change-end-days', value, day)
      },

      selectImage(imageId) {
        this.$emit('select-image', imageId)
      },
      
    },
  }
</script>